import { useQuery } from '@tanstack/react-query';

const CHECK_INTERVAL = 30000; // Check every 30 seconds

type UseNewItemsCheckParams<T, Q> = {
  queryKey: string;
  queryFn: (query: Q) => Promise<{ results: T[] }>;
  getId: (item: T) => string;
  query: Q;
  latestKnownId: string | undefined;
  enabled: boolean;
  onNewItems: () => void;
};

export const useNewItemsCheck = <T, Q>({
  queryKey,
  queryFn,
  getId,
  query,
  latestKnownId,
  enabled,
  onNewItems,
}: UseNewItemsCheckParams<T, Q>) => {
  return useQuery({
    queryKey: [queryKey, query],
    queryFn: () => queryFn(query),
    enabled: enabled && !!latestKnownId,
    refetchInterval: CHECK_INTERVAL,
    cacheTime: 0,
    staleTime: 0,
    onSuccess: (data: { results: T[] }) => {
      const latestServerItem = data?.results?.[0];
      const latestServerId = latestServerItem ? getId(latestServerItem) : null;
      const hasNewItems =
        !!latestServerId && !!latestKnownId && latestServerId !== latestKnownId;

      if (hasNewItems) {
        onNewItems();
      }
    },
  });
};
